import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CyberComponent from "containers/CyberComponent";
import LabTestInfo from "containers/request/Initial/LabTestInfo";
import LabTestResult from "containers/request/Initial/LabTestResult";
import RequestControls from "containers/request/RequestControls";
import { Bubble } from "ctia-ui";
import { updateRequestLab } from "actions/requestCyber";

class LabInfo extends CyberComponent {
  validate() {
    return this.props.request.cdmaLab > 0;
  }

  onSaveClick = () => {
    this.props.updateRequestLab(this.props.request);
  };

  render() {
    const { show, tests, user, canSubmit } = this.props;

    if (!show) return null;

    const testModule = tests ? tests[0] : null;
    const isEditable = user.canEditRequest || user.isStaff;
    const saveHandler = isEditable ? this.onSaveClick : null;

    return (
      <div>
        <Bubble show={canSubmit}>Please select a lab for the testing.</Bubble>
        <LabTestInfo editable={isEditable} />
        <LabTestResult testModule={testModule} />
        <RequestControls isValid={this.validate()} onSave={saveHandler} />
      </div>
    );
  }
}

LabInfo.propTypes = {
  show: PropTypes.bool,
  canSubmit: PropTypes.bool
};

LabInfo.defaultProps = {
  show: true,
  canSubmit: false
};

function mapStateToProps({ request, tests, user }) {
  return { request, tests, user };
}

export default connect(mapStateToProps, {
  updateRequestLab
})(LabInfo);
